enum ErrorMessageId {
  InvalidEmail = 'invalid-email',
  RequiredField = 'required-field',
  InvalidField = 'invalid-field',
  MaximumLength = 'maximum-length',
  MinimumLength = 'minimum-length',
}

export default ErrorMessageId;
